
export default {
  name: 'AtomLoaderProject',
  props: {}
}
